import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, mapAsOfSubtextDate } from "helpers/row-logic-helper";

const DEFAULT_WIDTH = 138;

export const rows = {
  propertyName: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Property Name",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "name"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  address: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Address",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => {
          const address = defaultField(data, "address");
          const city = defaultField(data, "city");
          const state = defaultField(data, "stateRef.value");
          const zip = defaultField(data, "zip");

          return `${address} \n${city}, ${state}, ${zip}`;
        },
        Cell: tableSideColumnMapper
      }
    ]
  },

  metropolitanStatisticalArea: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "MSA",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "metropolitanStatisticalArea.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  region: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Region",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "region.name"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
